import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["requisitionFunnel", "interactionFunnel"]

  connect() {
    // Funnel Filter Controller connected
  }

  submitForm() {
    // Form automatisch absenden mit Turbo
    const form = this.element.querySelector('form')
    if (form) {
      // Erstelle URLSearchParams für saubere URL-Konstruktion
      const formData = new FormData(form)
      const params = new URLSearchParams()
      
      // Füge alle Form-Parameter hinzu
      for (let [key, value] of formData.entries()) {
        if (value) { // Nur nicht-leere Werte hinzufügen
          params.append(key, value)
        }
      }
      
      // Konstruiere saubere URL
      const baseUrl = form.action.split('?')[0] // Entferne existierende Parameter
      const url = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl
      
      Turbo.visit(url, {
        frame: 'funnel_charts'
      })
    }
  }
}

